export default {"src":"/_next/static/media/check.c525b942.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};